import fetchFile from "./fetchFile";

import { riskColorHexMapping } from "@src/common/colors";
import { INITIAL_ASSESSMENT } from "@src/containers/Landing";
/*global pdfMake b*/
/*eslint no-undef: "error"*/
class PdfTemplate {
  generateDocument(state) {
    this.careType = state.sections.riskratings[state.careType].type;
    this.riskScore =
      state.sections.riskratings[state.careType].risks[state.riskScore].type;
    this.riskColor = riskColorHexMapping[state.riskScore];
    this.riskBannerTextColor = ["black", "black", "white", "white"][
      state.riskScore
    ];
    let dd = this.getBaseTemplate();
    dd.content.push(
      this.generateClientInfo(
        state.name,
        state.id,
        state.assessmentType === INITIAL_ASSESSMENT
      )
    );
    dd.content = dd.content.concat(
      this.generateRiskIndicators(state.sections.riskindicators)
    );
    dd.content = dd.content.concat(
      this.generateRiskRating(
        state.sections.riskratings[state.careType].risks[state.riskScore],
        state.sections.riskratings.title,
        state.sections.riskratings.comments,
        state.sections.riskratings.label
      )
    );
    dd.content = dd.content.concat(
      this.generateContributingFactors(state.sections.contributingfactors)
    );
    dd.content[dd.content.length - 1].pageBreak = false;
    dd.content.push({
      text: `Completed By (Name/Designation): ${"_".repeat(40)}`,
      style: "subTitle",
      margin: [0, 20, 47, 0],
      alignment: "right"
    });
    dd.content.push({
      text: `Date: ${"_".repeat(40)}`,
      style: "subTitle",
      alignment: "right",
      margin: [0, 10, 47, 0]
    });
    return dd;
  }
  generateClientInfo(name, id, initial) {
    name = name || "";
    id = id || "";
    name = name.trim();
    if (name.length > 29) {
      name = name.match(/\S{1,29}/g).join("\n");
    }
    id = id.trim();
    let emptyName = " ".repeat(496);
    let emptyId = " ".repeat(40);
    return [
      {
        text: "The ICRA toolkit has been developed to help identify behaviours and triggers associated with increased risk of violence so prevention measures for staff and the client may be taken.",
        margin: [0, 0, 0, 0]
      },
      {
        columns: [
          {
            stack: [
              {
                style: "subTitle",
                text: [
                  "Client Name: ",
                  {
                    text: name || emptyName,
                    decoration: !name ? "underline" : false,
                    decorationColor: "#888888",
                    bold: false,
                    fontSize: name ? 11 : 1
                  }
                ],
                margin: [0, 0, 0, 5]
              },
              name
                ? ""
                : {
                    style: "subTitle",
                    text: [
                      "Last Name: ",
                      {
                        text: " ".repeat(526),
                        decoration: !name ? "underline" : false,
                        decorationColor: "#888888",
                        bold: false,
                        fontSize: 1
                      }
                    ],
                    margin: [0, 0, 0, 5]
                  },
              {
                style: "subTitle",
                text: [
                  "Identification #: ",
                  {
                    text: id || emptyId,
                    decoration: !id ? "underline" : false,
                    decorationColor: "#888888",
                    bold: false
                  }
                ],
                margin: [0, 0, 0, 5]
              },
              {
                style: "subTitle",
                text: [
                  "Purpose: ",
                  {
                    text: initial ? "Initial Assessment" : "Reassessment",
                    bold: false
                  }
                ],
                margin: [0, 0, 0, 10]
              }
            ],
            width: 228
          },
          {
            color: "#bbbbbb",
            table: {
              widths: [275],
              body: [
                [
                  {
                    text: "Apply ID # sticker",
                    alignment: "center",
                    margin: [0, 30, 0, 30],
                    bold: true
                  }
                ]
              ]
            },
            width: 287,
            margin: [0, 0, 0, 5],
            layout: {
              hLineColor: function(i, node) {
                return "#bbbbbb";
              },
              vLineColor: function(i, node) {
                return "#bbbbbb";
              }
            }
          }
        ],
        margin: [0, 5, 0, 0]
      }
    ];
  }
  generateRiskIndicators(section) {
    let sections = [];
    section.subsections.forEach((subsection, index) => {
      sections = sections.concat(
        this.generateSection(
          `${section.label}. ${section.title}`,
          `${index + 1}. ${subsection.title}`,
          subsection.behaviours,
          subsection.comments,
          !sections.length || sections[sections.length - 1].table,
          true,
          index === 0
        )
      );
    });
    return sections;
  }
  generateRiskRating(section, title, comments, label) {
    let sections = [];
    sections = sections.concat(
      this.generateSection(
        `${label}. ${title}`,
        `${1}. Measures`,
        section.measures,
        comments,
        true
      )
    );
    return sections;
  }
  generateContributingFactors(section) {
    let sections = [];
    section.subsections.forEach((subsection, index) => {
      sections = sections.concat(
        this.generateSection(
          `${section.label}. ${section.title}`,
          `${index + 1}. ${subsection.title}`,
          subsection.factors,
          subsection.comments,
          !sections.length ||
            (sections[sections.length - 1].table && index === 0)
        )
      );
    });
    let partB = [sections[2], sections[3]];
    let partC = [sections[4], sections[5]];
    partB[0].table.widths = [20, 230];
    partC[0].table.widths = [20, 212];
    partC[1].margin = [5, 2, 0, 0];
    sections = [sections[0], sections[1], { columns: [partB, partC] }];
    return sections;
  }
  generateSection(
    title,
    tableHeader,
    rows,
    comments,
    hasHeader,
    yesNo,
    showPoints
  ) {
    let sectionTable = {
      table: {
        widths: [425, 70],
        headerRows: hasHeader ? 2 : 1,
        dontBreakRows: true,
        body: []
      },
      layout: {
        hLineWidth: function(i, node) {
          return i === node.table.headerRows ? 0 : 1;
        },
        vLineWidth: function(i, node) {
          return 1;
        },
        hLineColor: function(i, node) {
          return "#dddddd";
        },
        vLineColor: function(i, node) {
          return "#dddddd";
        },
        fillColor: function(i, node) {
          return i < node.table.headerRows && (i > 0 || !hasHeader)
            ? "#eeeeee"
            : "white";
        }
      }
    };
    if (hasHeader) {
      sectionTable.table.body.push([
        {
          text: title,
          style: "sectionTitle",
          alignment: "center",
          colSpan: 2,
          border: [false, false, false, false],
          margin: [0, 0, 0, 3]
        },
        {}
      ]);
    }
    sectionTable.table.body.push([
      {
        text: tableHeader,
        style: "subTitle",
        alignment: "center",
        colSpan: 2
      },
      {}
    ]);
    if (yesNo) {
      // sectionTable.table.body.push([
      //   {
      //     text: "Description",
      //     alignment: "center",
      //     style: "tableSubHeader",
      //     margin: [40, 0, 0, 0]
      //   },
      //   {
      //     text: "Yes/No",
      //     alignment: "center",
      //     style: "tableSubHeader"
      //   }
      // ]);
      for (let row of Object.values(rows)) {
        row.points = row.points || [];
        sectionTable.table.body.push([
          {
            stack: [
              {
                text: row.text,
                bold: showPoints,
                margin: showPoints ? [12, 3, 0, 0] : [14, 2, 0, 2]
              },
              !showPoints
                ? ""
                : {
                    ul: row.points.map(point => {
                      return { text: point, margin: [0, 3, 0, 0] };
                    }),
                    margin: [0, 0, 0, 5]
                  }
            ]
          },
          {
            text: this.getBooleanSymbol(row.checked, yesNo),
            alignment: "center",
            margin: [0, 1, 0, 1],
            bold: true
          }
        ]);
      }
    } else {
      sectionTable.table.widths = [20, 480];
      sectionTable.layout.vLineWidth = function(i, node) {
        return i === 1 ? 0 : 1;
      };
      // sectionTable.table.body.push([
      //   {
      //     text: "Description",
      //     alignment: "center",
      //     style: "tableSubHeader",
      //     colSpan: 2
      //   },
      //   ""
      // ]);
      for (let row of Object.values(rows)) {
        sectionTable.table.body.push([
          this.getBooleanSymbol(row.checked, yesNo),
          {
            stack: [
              {
                text: row.text,
                margin: [0, 3, 0, 0]
              }
            ]
          }
        ]);
      }
    }

    comments = comments || "";
    comments = comments.trim();
    let commentsTable = { text: "" };
    if (comments) {
      let commentsHeader = {
        text: "Comments: ",
        style: "commentsTitle"
      };
      let commentsBody = { text: comments };
      commentsTable = {
        margin: [0, 2, 0, 0],
        table: {
          headerRows: 1,
          body: [[commentsHeader], [commentsBody]]
        },
        layout: {
          hLineWidth: function(i, node) {
            return 0;
          },
          vLineWidth: function(i, node) {
            return 0;
          }
        }
      };
    }
    return [sectionTable, commentsTable];
  }

  header(currentPage, pageCount) {
    return [
      {
        stack: [
          {
            text: `${this.careType} Client Violence Risk Assessment Tool`,
            style: "toolHeader",
            margin: [0, 39, 0, 0],
            alignment: "left"
          }
        ],
        margin: [40, 0, 0, 0]
      },
      {
        table: {
          widths: [505],
          body: [
            [
              {
                text: `RISK RATING: ${this.riskScore.toUpperCase()}`,
                color: this.riskBannerTextColor,
                style: "purposeHeader",
                fillColor: this.riskColor,
                border: [false, false, false, false],
                margin: [2, 2, 2, 2]
              }
            ]
          ]
        },
        margin: [40, 5, 40, 0]
      }
    ];
  }

  footer(currentPage, pageCount) {
    return [
      {
        table: {
          widths: [505],
          headerRows: 1,
          body: [[{ text: "", border: [false, true, false, false] }]]
        },
        layout: {
          hLineWidth: function(i, node) {
            return 1;
          }
        },
        margin: [40, 0, 0, 0]
      },
      {
        text: "© Copyright 2017, Public Services Health and Safety Association. All rights reserved. Reproduction in whole or in part by any means without express written consent of Public Services Health and Safety Association is prohibited by law.",
        margin: [40, 0, 40, 0],
        style: "smallText"
      },
      {
        text: `${currentPage.toString()} of ${pageCount} pages`,
        margin: [0, 5, 40, 0],
        alignment: "right",
        style: "smallText",
        bold: true
      }
    ];
  }

  getBooleanSymbol(checked, yesNo) {
    if (yesNo) {
      return checked ? "Yes" : "No";
    }
    return checked
      ? { image: "checked", fit: [13, 13], margin: [0, 2, 0, 2] }
      : { image: "unchecked", fit: [13, 13], margin: [0, 2, 0, 2] };
  }
  getBaseTemplate() {
    return {
      footer: this.footer.bind(this),
      header: this.header.bind(this),
      pageMargins: [40, 90, 40, 70],
      content: [],
      styles: this.getStyles(),
      defaultStyle: {
        font: "gotham",
        fontSize: 10
      },
      images: {
        unchecked: require("@public/assets/icons/Circle_empty.png"),
        checked: require("@public/assets/icons/Checkmark_black.png")
      }
    };
  }
  getStyles() {
    return {
      purposeHeader: {
        fontSize: 16,
        bold: true
      },
      toolHeader: {
        fontSize: 16
      },
      sectionTitle: {
        fontSize: 12,
        bold: true,
        italics: true
      },
      commentsTitle: {
        fontSize: 12,
        bold: true
      },
      subTitle: {
        fontSize: 11,
        bold: true
      },
      tableSubHeader: {
        fontSize: 11,
        bold: true
      },
      smallText: {
        fontSize: 8
      }
    };
  }
}
function getFontsForPdf() {
  if (!pdfMake) {
    return;
  }
  pdfMake.vfs = {
    "Gotham-Book.otf": require("@public/assets/fonts/Gotham Fonts/Gotham-Book.otf"),
    "Gotham-Medium.otf": require("@public/assets/fonts/Gotham Fonts/Gotham-Medium.otf"),
    //"PSHSA_Logo.png": require("@public/assets/images/PSHSA_Logo.png"),
    "Gotham-Bold.otf": require("@public/assets/fonts/Gotham Fonts/Gotham-Bold.otf")
    //"Gotham-BookItalic.otf": require("@public/assets/fonts/Gotham Fonts/Gotham-BookItalic.otf"),
    //"Gotham-MediumItalic.otf": require("@public/assets/fonts/Gotham Fonts/Gotham-MediumItalic.otf")
  };
  pdfMake.fonts = {
    gotham: {
      normal: "Gotham-Book.otf",
      bold: "Gotham-Medium.otf",
      italics: "Gotham-BookItalic.otf",
      bolditalics: "Gotham-Bold.otf"
    }
  };
  let promisedImages = [];
  let addFile = res => (pdfMake.vfs[res.key] = res.file);
  for (let key in pdfMake.vfs) {
    promisedImages.push(fetchFile(pdfMake.vfs[key], key).then(addFile));
  }
  return Promise.all(promisedImages);
}
function generatePdf(state) {
  let template = new PdfTemplate();
  let dd = template.generateDocument(state);
  try {
    return pdfMake.createPdf(dd);
  } catch (err) {
    console.error(
      "PDF generation failed. Fonts for pdf probably not loaded yet."
    );
    console.error(err);
  }
}
function downloadPdf(state, filename) {
  const riskScore =
    state.sections.riskratings[state.careType].risks[state.riskScore].type;
  const careType = state.careType;
  let now = new Date();
  filename =
    filename ||
    `${careType}${riskScore}${now.getFullYear()}${now.getMonth() + 1}${now.getDay()}.pdf`;

  generatePdf(state).download(filename);
}
function printPdf(state) {
  const riskScore =
    state.sections.riskratings[state.careType].risks[state.riskScore].type;
  const careType = state.careType;
  let now = new Date();
  let filename = `${careType}${riskScore}${now.getFullYear()}${now.getMonth() + 1}${now.getDay()}.pdf`;
  let pdf = generatePdf(state);
  if (navigator.msSaveOrOpenBlob) {
    // IE10 can't do a[download], only Blobs:
    pdf.getBlob(blob => {
      navigator.msSaveOrOpenBlob(blob, filename);
    });
  } else {
    pdf.print();
  }
}

export { PdfTemplate, getFontsForPdf, downloadPdf, printPdf };



// WEBPACK FOOTER //
// ./src/pdf/documentTemplate.jsx